import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import * as moment from 'moment';
import { FileSystemFileEntry, NgxFileDropEntry } from 'ngx-file-drop';
import { PostalCodeAutocompleteService } from 'postal-code-autocomplete';
import { delay } from 'rxjs/operators';
import { ErrorFormatter } from '../../../shared/formatter/error.formatter';
import { BrandInput } from '../../../shared/models/brand/brand.input';
import { BrandFilter } from '../../../shared/models/brand/brandFilter';
import { ChannelInput } from '../../../shared/models/channel/channel.input';
import { ChannelFilter } from '../../../shared/models/channel/channelFilter';
import { PaginationInput } from '../../../shared/models/common/paginationInput';
import { DealerInput } from '../../../shared/models/dealer/dealer.input';
import { DealerFilter } from '../../../shared/models/dealer/dealerFilter';
import { GetOfferIdLeadsByOffersId } from '../../../shared/models/lead/getLeadByOffersId.input';
import { LeadImportInput } from '../../../shared/models/lead/leadImportInput';
import { LeadsImportInput } from '../../../shared/models/lead/leadsImport.input';
import { UserFilter } from '../../../shared/models/lead/userFilter';
import { UserInput } from '../../../shared/models/lead/userInput';
import { LeadArchivedOptionType } from '../../../shared/models/types/leadArchivedOption.type';
import { LeadOnTrackStatusType } from '../../../shared/models/types/leadOnTrackStatus.type';
import { CsvGeneratorService } from '../../../shared/services/csv-generation/csv-generator.service';
import { LeadService } from '../../../shared/services/lead/lead.service';
import { TranslatorService } from '../../../shared/services/utils/translator.service';
import { SharedHandlerService } from '../../../shared/shared.handler.service';
import { PlateValidator } from '../../../shared/validator/plate.validator';
import { LeadsComunicationService } from '../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../modals.handler.service';
import { ToastService } from './../../../shared/services/utils/toast.service';
import { SpanishIdisValid } from '../../../shared/validator/nif-cif-nie.validator';
import { PhoneService } from '../../../shared/services/utils/phone.service';

@Component({
  selector: 'ngx-import-csv',
  templateUrl: './import-csv.component.html',
  styleUrls: []
})
export class ImportCsvComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('content', { static: false }) content: ElementRef;
  @ViewChild('fileInputCsv', { static: false }) fileInputCsv: ElementRef;
  dropHereFileName: string;
  leadsImported: any[] = [];
  leadsCsvImported: any[] = [];
  subcriptionModal: any;
  importForm: any;
  files: NgxFileDropEntry[] = [];
  importStarted = false;
  progressStatus = 0;
  processChannels: boolean;
  processChannelsFinish: boolean;
  listCsvLeadInput: LeadImportInput[];
  listCsvLeadInputPaginated: any[];
  listCsvLeadInputData: LeadImportInput[];
  processStatusChannel: number;
  processStatusDealers: number;
  processStatusUsers: number;
  processStatusOfferId: number;
  processStatusBrands: number;
  headersStatusChannel: number;
  processStatusColumn: number;
  processStatusPrepareLeads: number;
  processStatusType: number;
  processStatusDate: number;
  processStatusSaveLeads: number;
  processStatusFields: number;
  sending = false;
  allowedStatus: string[];
  leadStatus: Array<{ status: string, trans: string }>;
  leadArchivedOptions;
  leadOnTrackOptions;

  private readonly steps = 9;
  private readonly progresSteps = 100 / this.steps;
  private readonly STATUS_WAIT = 0;
  private readonly STATUS_IN_PROGRESS = 1;
  private readonly STATUS_COMPLETE = 2;
  private readonly STATUS_ERROR = 3;
  private readonly STATUS_WARNING = 4;

  private readonly COLUMN_CONTACT_NAME = 0;
  private readonly COLUMN_CONTACT_PHONE = 1;
  private readonly COLUMN_CONTACT_EMAIL = 2;
  private readonly COLUMN_CONTACT_VAT = 3;
  private readonly COLUMN_CHANNEL = 4;
  private readonly COLUMN_ORIGIN = 5;
  private readonly COLUMN_TYPE = 6;
  private readonly COLUMN_BRAND = 7;
  private readonly COLUMN_DESCR_MODEL = 8;
  private readonly COLUMN_DEALER = 9;
  private readonly COLUMN_POSTAL_CODE = 10;
  private readonly COLUMN_ADDRESS = 11;
  private readonly COLUMN_COMMENT = 12;
  private readonly COLUMN_ID = 13;
  private readonly COLUMN_STATUS = 14;
  private readonly COLUMN_CREATED_DATE = 15;
  private readonly COLUMN_ON_TRACK_DATE = 16;
  private readonly COLUMN_TEMP = 17;
  private readonly COLUMN_CLOSE_DATE = 18;
  private readonly COLUMN_ARCHIVED_DATE = 19;
  private readonly COLUMN_ARCHIVED_TYPE = 20;
  private readonly COLUMN_ARCHIVED_COMMENT = 21;
  private readonly COLUMN_USER = 22;
  private readonly COLUMN_CLOSE_COMMENT = 23;
  private readonly COLUMN_ON_TRACK_COMMENT = 24;
  private readonly COLUMN_PLATE = 25;

  private readonly TOKEN_HEADER_NAME_LASTNAME = 'template.import.header.name_and_lastname';
  private readonly TOKEN_HEADER_PHONE = 'template.import.header.phone';
  private readonly TOKEN_HEADER_EMAIL = 'template.import.header.email';
  private readonly TOKEN_HEADER_VAT = 'template.import.header.vat';
  private readonly TOKEN_HEADER_STATUS = 'template.import.header.status';
  private readonly TOKEN_HEADER_COMMENT = 'template.import.header.comment';
  private readonly TOKEN_HEADER_ID = 'template.import.header.id';
  private readonly TOKEN_HEADER_USER = 'template.import.header.user';
  private readonly TOKEN_HEADER_CREATED_AT = 'template.import.header.createdAt';
  private readonly TOKEN_HEADER_ARCHIVED_DATE = 'template.import.header.archived_date';
  private readonly TOKEN_HEADER_TEMP = 'template.import.header.temp';
  private readonly TOKEN_HEADER_CLOSE_DATE = 'template.import.header.close_date';
  private readonly TOKEN_HEADER_ON_TRACK_DATE = 'template.import.header.on_track_date';
  private readonly TOKEN_HEADER_ARCHIVED_TYPE = 'template.import.header.archived_type';
  private readonly TOKEN_HEADER_PLATE = 'template.import.header.plate';

  private readonly POSTAL_CODE_COUNTRY = 'es';

  private errors: any[] = [];
  errorsData: any[] = [];
  errorsPaginated: any[] = [];

  private headers: any;

  constructor(private readonly modalsHandler: ModalsHandlerService,
    private readonly translateService: TranslatorService,
    private readonly modalService: NgbModal,
    private readonly leadService: LeadService,
    private readonly toastService: ToastService,
    private readonly errorFormatter: ErrorFormatter,
    private readonly leadComunicationService: LeadsComunicationService,
    private readonly csvService: CsvGeneratorService,
    private readonly postalCodeService: PostalCodeAutocompleteService,
    private readonly sharedHandlerService: SharedHandlerService) {
  }

  ngOnDestroy(): void {
    this.subcriptionModal.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.sharedHandlerService.paginate.pipe(delay(0)).subscribe((paginatedData) => {
      if (this.errors.length > 0 && this.processStatusSaveLeads !== this.STATUS_WARNING) {
        this.errorsPaginated = paginatedData;
        this.listCsvLeadInputPaginated = [];
      } else {
        this.errorsPaginated = [];
        this.listCsvLeadInputPaginated = paginatedData;
      }
    });
  }

  ngOnInit(): void {
    this.leadArchivedOptions = Object.entries(new LeadArchivedOptionType());
    this.leadArchivedOptions = this.leadArchivedOptions.map(leadArchivedOption => {
      return { type: leadArchivedOption[1], trans: this.translateService.trans(`lead_archived_type.${leadArchivedOption[1]}`) };
    });

    this.leadOnTrackOptions = Object.entries(new LeadOnTrackStatusType());
    this.leadOnTrackOptions = this.leadOnTrackOptions.map(leadOnTrackOption => {
      return { type: leadOnTrackOption[1], trans: this.translateService.trans(`pages.leads.status.${leadOnTrackOption[1]}`) };
    });

    this.leadStatus = [
      { status: 'new', trans: this.translateService.trans('pages.leads.status.new') },
      { status: 'on_track', trans: this.translateService.trans('pages.leads.status.on_track') },
      { status: 'archived', trans: this.translateService.trans('pages.leads.status.archived') },
      { status: 'closed', trans: this.translateService.trans('pages.leads.status.closed') }
    ];
    this.allowedStatus = this.leadStatus.map(leadStatus => leadStatus.trans);

    this.subcriptionModal = this.modalsHandler.importCsvModal.subscribe(() => {
      this.initImporter();
      this.modalService.open(this.content, {
        size: 'lg',
        windowClass: 'modal-xl-xl',
        container: 'nb-layout',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static', keyboard: false
      });
    });
  }

  openFileCsv(event: any): void {
    const input = event.target;
    const reader = new FileReader();
    this.readerOnload(reader);
    reader.readAsBinaryString(input.files[0]);
  }

  readFileCsv(reader: any): void {
    this.listCsvLeadInput = [];
    const text = reader.result;
    const dataCollection = text.split(/\r?\n/).filter(value =>
      value !== '');
    this.importStarted = true;
    this.headersStatusChannel = this.STATUS_IN_PROGRESS;
    this.headers = dataCollection[0].split(';');
    if (!this.checkHeaders(this.headers)) {
      this.headersStatusChannel = this.STATUS_ERROR;
      this.processStatusSaveLeads = this.STATUS_ERROR;
      this.errors.push({
        name: 'headers',
        message: this.translateService.trans('pages.leads.import.error.headers'),
        type: 'error'
      }
      );

      return;
    }
    this.progressStatus += this.progresSteps;
    this.headersStatusChannel = this.STATUS_COMPLETE;
    dataCollection.shift();

    // TODO: Limitar lead
    const channels = [];
    const dealers = [];
    const brands = [];
    const users = [];
    const ids = [];
    this.leadsCsvImported = [];
    this.processStatusColumn = this.STATUS_IN_PROGRESS;
    const progressPerItem = this.progresSteps / dataCollection.length;
    dataCollection.map((lead, index) => {
      this.progressStatus += progressPerItem;
      const leadTemp = lead.replace(/"/g, '').replace(/¶/g, '\n').split(';');
      if (leadTemp.length >= this.headers.length) {
        this.leadsCsvImported.push(leadTemp);
        channels.push(leadTemp[this.COLUMN_CHANNEL]);
        dealers.push(leadTemp[this.COLUMN_DEALER]);
        brands.push(leadTemp[this.COLUMN_BRAND]);
        users.push(leadTemp[this.COLUMN_USER]);
        ids.push(leadTemp[this.COLUMN_ID]);
      } else {
        this.errors.push(
          {
            name: this.translateService.trans('modals.importer.file'),
            message: this.translateService.trans('modals.importer.columns_is_not_correct'),
            type: 'error',
            line: index + 2,
            leadN: index + 1
          });
      }

    });
    if (this.errors.length > 0) {
      this.processStatusSaveLeads = this.STATUS_ERROR;
      this.processStatusColumn = this.STATUS_ERROR;

      return;
    }
    this.processStatusColumn = this.STATUS_COMPLETE;

    this.processStatusFields = this.STATUS_IN_PROGRESS;

    this.checkFields(this.leadsCsvImported);

    this.processStatusDate = this.STATUS_IN_PROGRESS;

    if (this.errors.length > 0) {
      this.processStatusSaveLeads = this.STATUS_ERROR;
      this.processStatusFields = this.STATUS_ERROR;
    } else {
      this.processStatusFields = this.STATUS_COMPLETE;
    }
    const errorsCount = this.errors.length;
    this.checkDateFormat();

    if (this.errors.length > errorsCount) {
      this.processStatusSaveLeads = this.STATUS_ERROR;
      this.processStatusDate = this.STATUS_ERROR;
    }
    this.getIdsByName({ channels, dealers, brands, users, ids });
  }
  checkHeaders(headers: any): any {
    const headersMod = headers;

    return this.checkHeader(headersMod[0],this.translateService.trans(this.TOKEN_HEADER_NAME_LASTNAME)) &&
      this.checkHeader(headersMod[1],this.translateService.trans(this.TOKEN_HEADER_PHONE)) &&
      this.checkHeader(headersMod[2],this.translateService.trans(this.TOKEN_HEADER_EMAIL)) &&
      this.checkHeader(headersMod[3],this.translateService.trans(this.TOKEN_HEADER_VAT)) &&
      this.checkHeader(headersMod[4],this.translateService.trans('template.import.header.channel')) &&
      this.checkHeader(headersMod[5],this.translateService.trans('template.import.header.origin')) &&
      this.checkHeader(headersMod[6],this.translateService.trans('template.import.header.type')) &&
      this.checkHeader(headersMod[7],this.translateService.trans('template.import.header.brand')) &&
      this.checkHeader(headersMod[8],this.translateService.trans('template.import.header.description_model')) &&
      this.checkHeader(headersMod[9],this.translateService.trans('template.import.header.dealer')) &&
      this.checkHeader(headersMod[10],this.translateService.trans('template.import.header.postal_code')) &&
      this.checkHeader(headersMod[10],this.translateService.trans('template.import.header.address')) &&
      this.checkHeader(headersMod[11],this.translateService.trans('template.import.header.comment')) &&
      this.checkHeader(headersMod[12],this.translateService.trans('template.import.header.id')) &&
      this.checkHeader(headersMod[13],this.translateService.trans('template.import.header.status')) &&
      this.checkHeader(headersMod[14],this.translateService.trans('template.import.header.createdAt')) &&
      this.checkHeader(headersMod[15],this.translateService.trans('template.import.header.on_track_date')) &&
      this.checkHeader(headersMod[16],this.translateService.trans('template.import.header.temp')) &&
      this.checkHeader(headersMod[17],this.translateService.trans('template.import.header.close_date')) &&
      this.checkHeader(headersMod[18],this.translateService.trans('template.import.header.archived_date')) &&
      this.checkHeader(headersMod[19],this.translateService.trans('template.import.header.archived_type')) &&
      this.checkHeader(headersMod[20],this.translateService.trans('template.import.header.archived_comment')) &&
      this.checkHeader(headersMod[21],this.translateService.trans('template.import.header.user')) &&
      this.checkHeader(headersMod[22],this.translateService.trans('template.import.header.close_comment')) &&
      this.checkHeader(headersMod[23],this.translateService.trans('template.import.header.on_track_comment')) &&
      this.checkHeader(headersMod[24],this.translateService.trans('template.import.header.plate'));
  }


  private checkHeader(header: any, reference: any): any {
    if (header === reference || header === '"' + reference + '"') {
      return true;
    }
    return false;
  }

  getIdsByName(names: any): void {
    const channelInput = new ChannelInput();
    channelInput.filter = new ChannelFilter();
    channelInput.filter.names = Array.from(new Set(names.channels));

    const brandInput = new BrandInput();
    brandInput.filter = new BrandFilter();
    brandInput.filter.names = Array.from(new Set(names.brands));

    const dealerInput = new DealerInput();
    dealerInput.filter = new DealerFilter();
    dealerInput.filter.names = Array.from(new Set(names.dealers));

    const userInput = new UserInput(new PaginationInput(null, null), new UserFilter());

    const getLeadsByOffersId = new GetOfferIdLeadsByOffersId(Array.from(new Set(names.ids.filter(ids => ids !== ''))));

    this.leadService.validateCsv(brandInput, dealerInput, channelInput, userInput, getLeadsByOffersId).subscribe(res => {
      this.checkChannels(res.data.getChannels.channels);
      this.checkBrands(res.data.getBrands.brands);
      this.checkDealers(res.data.getDealers.dealers);
      this.checkUsers(res.data.getUsers.users);
      this.checkBulk(res.data.getOfferIdLeadsByOfferId.leads);
      this.mapType(res.data.getLeadTypes.types);
      this.createLeads(res.data);
      this.errorsData = _.orderBy(this.errors, ['leadN'], ['asc']);
    }, err => {
      this.processStatusSaveLeads = this.STATUS_ERROR;
      this.toastService
        .showToast(
          'error',
          'Error',
          this.errorFormatter.formatErrors(err)
        );
    });
  }

  createLeads(data: any): any {
    this.processStatusPrepareLeads = this.STATUS_IN_PROGRESS;

    const progressPerItem = this.progresSteps / this.leadsCsvImported.length;
    this.listCsvLeadInput = [];
    for (const lead of this.leadsCsvImported) {
      const channelFind = data.getChannels.channels.find((channel: any): any =>
        channel.name.toLowerCase() === lead[this.COLUMN_CHANNEL].toLowerCase());

      const brandFind = data.getBrands.brands.find((brand: any): any =>
        brand.name.toLowerCase() === lead[this.COLUMN_BRAND].toLowerCase());

      const dealerFind = data.getDealers.dealers.find((dealer: any): any =>
        dealer.name.toLowerCase() === lead[this.COLUMN_DEALER].toLowerCase());

      const userFind = data.getUsers.users.find((user: any): any =>
        user.name.toLowerCase() === lead[this.COLUMN_USER].toLowerCase());

      const rawPostalCode = lead[this.COLUMN_POSTAL_CODE];

      const postalCode = this.postalCodeService.getZipCodeByCode(this.POSTAL_CODE_COUNTRY, rawPostalCode);
      // TODO Create object of type LeadInput instead of Object
      const leadInput = {
        contactName: lead[this.COLUMN_CONTACT_NAME],
        contactPhone: lead[this.COLUMN_CONTACT_PHONE],
        contactEmail: lead[this.COLUMN_CONTACT_EMAIL],
        vat: lead[this.COLUMN_CONTACT_VAT],
        descriptionModel: lead[this.COLUMN_DESCR_MODEL],
        type: lead[this.COLUMN_TYPE],
        brandName: brandFind ? brandFind.name : '',
        brand: brandFind ? brandFind.id : '',
        channelName: channelFind ? channelFind.name : '',
        channel: channelFind ? channelFind.id : '',
        dealerName: dealerFind ? dealerFind.name : '',
        dealer: dealerFind ? dealerFind.id : '',
        origin: lead[this.COLUMN_ORIGIN],
        postalCode: postalCode ? postalCode.zipcode : (isNaN(Number(rawPostalCode)) ? '' : rawPostalCode),
        location: postalCode ? `${postalCode ? postalCode.city + ', ' : ''} ${postalCode ? postalCode.state : ''}`
          : (isNaN(Number(rawPostalCode)) ? rawPostalCode : ''),
        address: lead[this.COLUMN_ADDRESS],
        comments: lead[this.COLUMN_COMMENT],
        offerId: lead[this.COLUMN_ID],
        status: lead[this.COLUMN_STATUS],
        createdAt: lead[this.COLUMN_CREATED_DATE],
        onTrackDate: lead[this.COLUMN_ON_TRACK_DATE],
        temp: lead[this.COLUMN_TEMP],
        closeDate: lead[this.COLUMN_CLOSE_DATE],
        archivedDate: lead[this.COLUMN_ARCHIVED_DATE],
        archivedType: lead[this.COLUMN_ARCHIVED_TYPE],
        archivedComment: lead[this.COLUMN_ARCHIVED_COMMENT],
        user: userFind ? userFind.id : '',
        userName: userFind ? userFind.name : '',
        closeComment: lead[this.COLUMN_CLOSE_COMMENT],
        onTrackComment: lead[this.COLUMN_ON_TRACK_COMMENT],
        plate: lead[this.COLUMN_PLATE].toUpperCase(),
      };

      this.listCsvLeadInput.push(leadInput);
      this.progressStatus += progressPerItem;
    }
    this.listCsvLeadInputData = this.listCsvLeadInput;
    this.processStatusPrepareLeads = this.STATUS_COMPLETE;
  }

  downloadTemplate(): void {
    const headersTemplate = [];
    headersTemplate[0] = this.translateService.trans(this.TOKEN_HEADER_NAME_LASTNAME);
    headersTemplate[1] = this.translateService.trans(this.TOKEN_HEADER_PHONE);
    headersTemplate[2] = this.translateService.trans(this.TOKEN_HEADER_EMAIL);
    headersTemplate[3] = this.translateService.trans(this.TOKEN_HEADER_VAT);
    headersTemplate[4] = this.translateService.trans('template.import.header.channel');
    headersTemplate[5] = this.translateService.trans('template.import.header.origin');
    headersTemplate[6] = this.translateService.trans('template.import.header.type');
    headersTemplate[7] = this.translateService.trans('template.import.header.brand');
    headersTemplate[8] = this.translateService.trans('template.import.header.description_model');
    headersTemplate[9] = this.translateService.trans('template.import.header.dealer');
    headersTemplate[10] = this.translateService.trans('template.import.header.postal_code');
    headersTemplate[11] = this.translateService.trans('template.import.header.comment');
    headersTemplate[12] = this.translateService.trans('template.import.header.id');
    headersTemplate[13] = this.translateService.trans('template.import.header.status');
    headersTemplate[14] = this.translateService.trans('template.import.header.createdAt');
    headersTemplate[15] = this.translateService.trans('template.import.header.on_track_date');
    headersTemplate[16] = this.translateService.trans('template.import.header.temp');
    headersTemplate[17] = this.translateService.trans('template.import.header.close_date');
    headersTemplate[18] = this.translateService.trans('template.import.header.archived_date');
    headersTemplate[19] = this.translateService.trans('template.import.header.archived_type');
    headersTemplate[20] = this.translateService.trans('template.import.header.archived_comment');
    headersTemplate[21] = this.translateService.trans('template.import.header.user');
    headersTemplate[22] = this.translateService.trans('template.import.header.close_comment');
    headersTemplate[23] = this.translateService.trans('template.import.header.on_track_comment');
    headersTemplate[24] = this.translateService.trans('template.import.header.plate');

    const options = {
      fieldSeparator: ';',
      showLabels: true,
      headers: headersTemplate
    };
    this.csvService.generateCsv([], this.translateService.trans('template.import.name_file'), options);
  }

  initImporter(): void {
    this.sending = true;
    this.importStarted = false;
    this.progressStatus = 0;
    this.processStatusChannel = this.STATUS_WAIT;
    this.processStatusDealers = this.STATUS_WAIT;
    this.processStatusUsers = this.STATUS_WAIT;
    this.processStatusOfferId = this.STATUS_WAIT;
    this.processStatusBrands = this.STATUS_WAIT;
    this.headersStatusChannel = this.STATUS_WAIT;
    this.processStatusColumn = this.STATUS_WAIT;
    this.processStatusPrepareLeads = this.STATUS_WAIT;
    this.processStatusType = this.STATUS_WAIT;
    this.processStatusDate = this.STATUS_WAIT;
    this.processStatusSaveLeads = this.STATUS_WAIT;
    this.processStatusFields = this.STATUS_WAIT;
    this.errors = [];
    this.errorsData = [];
    this.listCsvLeadInputData = [];
    this.dropHereFileName = this.translateService.trans('pages.leads.drop_file_here');
    this.sending = false;
    this.errorsPaginated = [];
    this.listCsvLeadInputPaginated = [];
  }

  doImport(): void {
    this.sending = true;
    this.processStatusSaveLeads = this.STATUS_IN_PROGRESS;
    const leadCsvImport = new LeadsImportInput();
    leadCsvImport.leadsImport = this.listCsvLeadInput.map(lead => {
      const leadCsvInput = new LeadImportInput();
      leadCsvInput.contactName = lead.contactName;
      leadCsvInput.contactPhone = lead.contactPhone;
      leadCsvInput.contactEmail = lead.contactEmail;
      leadCsvInput.vat = lead.vat;
      leadCsvInput.descriptionModel = lead.descriptionModel;
      leadCsvInput.type = lead.type;
      leadCsvInput.brand = lead.brand;
      leadCsvInput.channel = lead.channel;
      leadCsvInput.origin = lead.origin;
      leadCsvInput.dealer = lead.dealer;
      leadCsvInput.postalCode = lead.postalCode;
      leadCsvInput.location = lead.location;
      leadCsvInput.address = lead.address;
      leadCsvInput.comments = lead.comments;
      leadCsvInput.offerId = lead.offerId;
      leadCsvInput.status = this.leadStatus.find(leadStatus => leadStatus.trans === lead.status).status;
      leadCsvInput.createdAt = lead.createdAt;
      leadCsvInput.onTrackDate = lead.onTrackDate;
      leadCsvInput.temp = lead.temp ? this.leadOnTrackOptions.find(onTrackOptions => onTrackOptions.trans === lead.temp).type : '';
      leadCsvInput.closeDate = lead.closeDate;
      leadCsvInput.archivedDate = lead.archivedDate;
      leadCsvInput.archivedType = lead.archivedType ? this.leadArchivedOptions.find(leadArchived => leadArchived.trans === lead.archivedType).type : '';
      leadCsvInput.archivedComment = lead.archivedComment;
      leadCsvInput.user = lead.user;
      leadCsvInput.closeComment = lead.closeComment;
      leadCsvInput.onTrackComment = lead.onTrackComment;
      leadCsvInput.plate = lead.plate;

      return leadCsvInput;
    });

    this.leadService.importLeads$(leadCsvImport).subscribe(() => {
      this.progressStatus = 100;
      this.processStatusSaveLeads = this.STATUS_COMPLETE;
      this.sending = false;
      this.leadComunicationService.launchReloadLeads();
      this.modalService.dismissAll();
      this.toastService.showToast('success', 'modals.importer.toast.success', 'modals.importer.toast.success.info');
    }, () => {
      this.toastService.showToast('error', 'modals.importer.toast.error', 'modals.importer.toast.error.info');
      this.processStatusSaveLeads = this.STATUS_ERROR;
      this.sending = false;
    });
  }

  checkFields(leadCsv: any): void {
    const progressPerItem = this.progresSteps / this.leadsCsvImported.length;

    const leadCsvIds = leadCsv.map(id => id[this.COLUMN_ID]);
    const duplicatedIds = _.filter(leadCsvIds, (val, i, iteratee) => _.includes(iteratee, val, i + 1));
    for (let i = 0; i < leadCsv.length; i++) {
      const lead = leadCsv[i];

      if (!lead[this.COLUMN_CONTACT_NAME]) {
        this.errors.push({
          name: this.translateService.trans(this.TOKEN_HEADER_NAME_LASTNAME),
          message: this.translateService.trans('modals.importer.name_is_a_required_field')+': '+lead[this.COLUMN_CONTACT_NAME],
          type: 'error',
          line: i + 2,
          leadN: i + 1
        });
        this.processStatusFields = this.STATUS_ERROR;
      }
      if (!lead[this.COLUMN_CONTACT_PHONE] && !lead[this.COLUMN_CONTACT_EMAIL]) {
        this.errors.push({
          name: `${this.translateService.trans(this.TOKEN_HEADER_EMAIL)}/${this.translateService.trans(this.TOKEN_HEADER_PHONE)}`,
          message: this.translateService.trans('modals.importer.email_phone_is_required'),
          type: 'error',
          line: i + 2,
          leadN: i + 1
        });
        this.processStatusFields = this.STATUS_ERROR;
      }
      if (lead[this.COLUMN_CONTACT_PHONE] && !this.validatePhone(lead[this.COLUMN_CONTACT_PHONE])) {
        this.errors.push({
          name: `${this.translateService.trans(this.TOKEN_HEADER_PHONE)}`,
          message: this.translateService.trans('modals.importer.phone_invalid')+': '+lead[this.COLUMN_CONTACT_PHONE],
          type: 'error',
          line: i + 2,
          leadN: i + 1
        });
        this.processStatusFields = this.STATUS_ERROR;
      }
      if (lead[this.COLUMN_CONTACT_EMAIL] && !this.validateEmail(lead[this.COLUMN_CONTACT_EMAIL])) {
        this.errors.push({
          name: `${this.translateService.trans(this.TOKEN_HEADER_EMAIL)}`,
          message: this.translateService.trans('error.email_is_not_valid')+': '+lead[this.COLUMN_CONTACT_EMAIL],
          type: 'error',
          line: i + 2,
          leadN: i + 1
        });
        this.processStatusFields = this.STATUS_ERROR;
      }
      // temporalmente se permite CIF no validos por si son CIFS de otros paises
      // if (lead[this.COLUMN_CONTACT_VAT] && !this.validateVat(lead[this.COLUMN_CONTACT_VAT])) {
      //   this.errors.push({
      //     name: `${this.translateService.trans(this.TOKEN_HEADER_VAT)}`,
      //     message: this.translateService.trans('error.vat_is_not_valid')+': '+lead[this.COLUMN_CONTACT_VAT],
      //     type: 'error',
      //     line: i + 2,
      //     leadN: i + 1
      //   });
      //   this.processStatusFields = this.STATUS_ERROR;
      // }      
      if (!lead[this.COLUMN_STATUS]) {
        this.errors.push({
          name: `${this.translateService.trans(this.TOKEN_HEADER_STATUS)}`,
          message: this.translateService.trans('modals.importer.status_is_required'),
          type: 'error',
          line: i + 2,
          leadN: i + 1
        });
        this.processStatusFields = this.STATUS_ERROR;
      }
      if (lead[this.COLUMN_COMMENT].length > 200000) {
        this.errors.push({
          name: `${this.translateService.trans(this.TOKEN_HEADER_COMMENT)}`,
          message: this.translateService.trans('modals.importer.comment_max_size')+" Longitud:"+lead[this.COLUMN_COMMENT].length,
          type: 'error',
          line: i + 2,
          leadN: i + 1
        });
        this.processStatusFields = this.STATUS_ERROR;
      }
      if (lead[this.COLUMN_ID] !== '' && duplicatedIds.includes(lead[this.COLUMN_ID])) {
        this.errors.push({
          name: this.translateService.trans(this.TOKEN_HEADER_ID),
          message: this.translateService.trans('modals.importer.id_is_duplicated')+': '+lead[this.COLUMN_ID],
          type: 'error',
          line: i + 2,
          leadN: i + 1
        });
        this.processStatusFields = this.STATUS_ERROR;
      }

      if (lead[this.COLUMN_STATUS] && !this.allowedStatus.includes(lead[this.COLUMN_STATUS])) {
        this.errors.push({
          name: `${this.translateService.trans(this.TOKEN_HEADER_STATUS)}`,
          message: this.translateService.trans('modals.importer.status_invalid_option')+': '+lead[this.COLUMN_STATUS],
          type: 'error',
          line: i + 2,
          leadN: i + 1
        });
        this.processStatusFields = this.STATUS_ERROR;
      }
      if (lead[this.COLUMN_CREATED_DATE]) {
        if (!moment(lead[this.COLUMN_CREATED_DATE], 'DD/MM/YYYY').isBefore(moment())) {
          console.log(lead);
          this.errors.push(
            {
              name: `${this.translateService.trans(this.TOKEN_HEADER_CREATED_AT)}`,
              message: `${this.translateService.trans('modals.importer.date_less_now')}`+': '+lead[this.COLUMN_CREATED_DATE],
              type: 'error',
              line: i + 2,
              leadN: i + 1
            });
        }
      }
      if (lead[this.COLUMN_STATUS] && lead[this.COLUMN_STATUS] === this.allowedStatus[1]) {
        if (!lead[this.COLUMN_CREATED_DATE]) {
          this.errors.push({
            name: `${this.translateService.trans(this.TOKEN_HEADER_CREATED_AT)}`,
            message: `${this.translateService.trans('modals.importer.created_date_required')}`,
            type: 'error',
            line: i + 2,
            leadN: i + 1
          });
        }
        if (!lead[this.COLUMN_ON_TRACK_DATE]) {
          this.errors.push({
            name: `${this.translateService.trans(this.TOKEN_HEADER_ON_TRACK_DATE)}`,
            message: `${this.translateService.trans('modals.importer.on_track_date_required')}`,
            type: 'error',
            line: i + 2,
            leadN: i + 1
          });
        }
        if (lead[this.COLUMN_ON_TRACK_DATE]) {
          if (!moment(lead[this.COLUMN_ON_TRACK_DATE], 'DD/MM/YYYY').isBefore(moment())) {
            this.errors.push(
              {
                name: `${this.translateService.trans(this.TOKEN_HEADER_ON_TRACK_DATE)}`,
                message: `${this.translateService.trans('modals.importer.date_less_now')}`+': '+lead[this.COLUMN_ON_TRACK_DATE],
                type: 'error',
                line: i + 2,
                leadN: i + 1
              });
          } else if (moment(lead[this.COLUMN_ON_TRACK_DATE], 'DD/MM/YYYY').isBefore(moment(lead[this.COLUMN_CREATED_DATE], 'DD/MM/YYYY'), 'day')) {
            this.errors.push(
              {
                name: `${this.translateService.trans(this.TOKEN_HEADER_ON_TRACK_DATE)}`,
                message: `${this.translateService.trans('modals.importer.date_less_created')}`,
                type: 'error',
                line: i + 2,
                leadN: i + 1
              });
          }
        }

        this.processStatusFields = this.STATUS_ERROR;
      }

      if (lead[this.COLUMN_STATUS] && lead[this.COLUMN_STATUS] === this.allowedStatus[2]) {
        if (!lead[this.COLUMN_ARCHIVED_TYPE]) {
          this.errors.push({
            name: `${this.translateService.trans(this.TOKEN_HEADER_ARCHIVED_TYPE)}`,
            message: `${this.translateService.trans('modals.importer.archived_type_required')}`,
            type: 'error',
            line: i + 2,
            leadN: i + 1
          });
        }
        if (lead[this.COLUMN_ARCHIVED_TYPE] && !(this.leadArchivedOptions.map(option => option.trans)).includes(lead[this.COLUMN_ARCHIVED_TYPE])) {
          this.errors.push({
            name: `${this.translateService.trans(this.TOKEN_HEADER_ARCHIVED_TYPE)}`,
            message: `${this.translateService.trans('modals.importer.archived_type_incorrect')}`+': '+lead[this.COLUMN_ARCHIVED_TYPE],
            type: 'error',
            line: i + 2,
            leadN: i + 1
          });
        }
        if (!lead[this.COLUMN_CREATED_DATE]) {
          this.errors.push({
            name: `${this.translateService.trans(this.TOKEN_HEADER_CREATED_AT)}`,
            message: `${this.translateService.trans('modals.importer.created_date_required')}`,
            type: 'error',
            line: i + 2,
            leadN: i + 1
          });
        }
        if (!lead[this.COLUMN_ARCHIVED_DATE]) {
          this.errors.push({
            name: `${this.translateService.trans(this.TOKEN_HEADER_ARCHIVED_DATE)}`,
            message: `${this.translateService.trans('modals.importer.archived_date_required')}`,
            type: 'error',
            line: i + 2,
            leadN: i + 1
          });
        }
        if (lead[this.COLUMN_ARCHIVED_DATE]) {
          if (!moment(lead[this.COLUMN_ARCHIVED_DATE], 'DD/MM/YYYY').isBefore(moment())) {
            this.errors.push(
              {
                name: `${this.translateService.trans(this.TOKEN_HEADER_ARCHIVED_DATE)}`,
                message: `${this.translateService.trans('modals.importer.date_less_now')}`+': '+lead[this.COLUMN_ARCHIVED_DATE],
                type: 'error',
                line: i + 2,
                leadN: i + 1
              });
          } else if (moment(lead[this.COLUMN_ARCHIVED_DATE], 'DD/MM/YYYY').isBefore(moment(lead[this.COLUMN_CREATED_DATE], 'DD/MM/YYYY'), 'day')) {
            this.errors.push(
              {
                name: `${this.translateService.trans(this.TOKEN_HEADER_ARCHIVED_DATE)}`,
                message: `${this.translateService.trans('modals.importer.date_less_created')}`,
                type: 'error',
                line: i + 2,
                leadN: i + 1
              });
          }
        }

        this.processStatusFields = this.STATUS_ERROR;
      }
      if (lead[this.COLUMN_STATUS] && (lead[this.COLUMN_STATUS] === this.allowedStatus[1] || lead[this.COLUMN_STATUS] === this.allowedStatus[3])) {
        const messages = [];
        if (!lead[this.COLUMN_TEMP]) {
          messages.push(this.translateService.trans('modals.importer.temp_required'));
        }
        if (lead[this.COLUMN_TEMP] && !(this.leadOnTrackOptions.map(option => option.trans)).includes(lead[this.COLUMN_TEMP])) {

          messages.push(this.translateService.trans('modals.importer.temp_invalid_option')+': '+lead[this.COLUMN_TEMP]);
        }
        messages.forEach(message => {
          this.errors.push({
            name: `${this.translateService.trans(this.TOKEN_HEADER_TEMP)}`,
            message: `${message}`,
            type: 'error',
            line: i + 2,
            leadN: i + 1
          });
        });
        this.processStatusFields = this.STATUS_ERROR;
      }

      if (lead[this.COLUMN_STATUS] && lead[this.COLUMN_STATUS] === this.allowedStatus[3]) {
        if (!lead[this.COLUMN_CREATED_DATE]) {
          this.errors.push({
            name: `${this.translateService.trans(this.TOKEN_HEADER_CREATED_AT)}`,
            message: `${this.translateService.trans('modals.importer.created_date_required')}`,
            type: 'error',
            line: i + 2,
            leadN: i + 1
          });
        }
        if (!lead[this.COLUMN_CLOSE_DATE]) {
          this.errors.push({
            name: `${this.translateService.trans(this.TOKEN_HEADER_CLOSE_DATE)}`,
            message: `${this.translateService.trans('modals.importer.close_date_required')}`,
            type: 'error',
            line: i + 2,
            leadN: i + 1
          });
        }
        if (!lead[this.COLUMN_ON_TRACK_DATE]) {
          this.errors.push({
            name: `${this.translateService.trans(this.TOKEN_HEADER_ON_TRACK_DATE)}`,
            message: `${this.translateService.trans('modals.importer.on_track_date_required')}`,
            type: 'error',
            line: i + 2,
            leadN: i + 1
          });
        }
        if (lead[this.COLUMN_ON_TRACK_DATE]) {
          if (!moment(lead[this.COLUMN_ON_TRACK_DATE], 'DD/MM/YYYY').isBefore(moment())) {
            this.errors.push(
              {
                name: `${this.translateService.trans(this.TOKEN_HEADER_ON_TRACK_DATE)}`,
                message: `${this.translateService.trans('modals.importer.date_less_now')}`+': '+lead[this.COLUMN_ON_TRACK_DATE],
                type: 'error',
                line: i + 2,
                leadN: i + 1
              });
          } else if (moment(lead[this.COLUMN_ON_TRACK_DATE], 'DD/MM/YYYY').isBefore(moment(lead[this.COLUMN_CREATED_DATE], 'DD/MM/YYYY'), 'day')) {
            this.errors.push(
              {
                name: `${this.translateService.trans(this.TOKEN_HEADER_ON_TRACK_DATE)}`,
                message: `${this.translateService.trans('modals.importer.date_less_created')}`,
                type: 'error',
                line: i + 2,
                leadN: i + 1
              });
          }
        }
        if (lead[this.COLUMN_CLOSE_DATE]) {
          if (!moment(lead[this.COLUMN_CLOSE_DATE], 'DD/MM/YYYY').isBefore(moment())) {
            this.errors.push(
              {
                name: `${this.translateService.trans(this.TOKEN_HEADER_CLOSE_DATE)}`,
                message: `${this.translateService.trans('modals.importer.date_less_now')}`+': '+lead[this.COLUMN_CLOSE_DATE],
                type: 'error',
                line: i + 2,
                leadN: i + 1
              });
          } else if (moment(lead[this.COLUMN_CLOSE_DATE], 'DD/MM/YYYY').isBefore(moment(lead[this.COLUMN_ON_TRACK_DATE], 'DD/MM/YYYY'), 'day')) {
            this.errors.push(
              {
                name: `${this.translateService.trans(this.TOKEN_HEADER_CLOSE_DATE)}`,
                message: `${this.translateService.trans('modals.importer.date_less_ontrack')}`,
                type: 'error',
                line: i + 2,
                leadN: i + 1
              });
          }
        }

        this.processStatusFields = this.STATUS_ERROR;
      }
      if (lead[this.COLUMN_PLATE] && !PlateValidator.isValidPlate(lead[this.COLUMN_PLATE])) {
        this.errors.push({
          name: `${this.translateService.trans(this.TOKEN_HEADER_PLATE)}`,
          message: `${this.translateService.trans('modals.importer.invalid_plate')}`+': '+lead[this.COLUMN_PLATE],
          type: 'error',
          line: i + 2,
          leadN: i + 1
        });
        this.processStatusFields = this.STATUS_ERROR;
      }

      if (this.allowedStatus.includes(lead[this.COLUMN_STATUS]) && lead[this.COLUMN_STATUS] !== this.allowedStatus[0] && !lead[this.COLUMN_USER]) {
        this.errors.push({
          name: `${this.translateService.trans(this.TOKEN_HEADER_USER)}`,
          message: this.translateService.trans('modals.importer.user_is_required'),
          type: 'error',
          line: i + 2,
          leadN: i + 1
        });
        this.processStatusFields = this.STATUS_ERROR;
      }
      this.progressStatus += progressPerItem;
    }
  }

  private checkDateFormat() {
    this.processStatusDate = this.STATUS_IN_PROGRESS;
    const progressPerItem = this.progresSteps / this.leadsCsvImported.length;
    for (let i = 0; i < this.leadsCsvImported.length; i++) {
      if (this.leadsCsvImported[i][this.COLUMN_CREATED_DATE]) {
        if (moment(this.leadsCsvImported[i][this.COLUMN_CREATED_DATE], 'DD/MM/YYYY', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_CREATED_DATE], 'DD/M/YYYY', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_CREATED_DATE], 'DD/MM/YYYY H:mm:ss', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_CREATED_DATE], 'DD/M/YYYY H:mm:ss', true).isValid()) {
        } else {
          this.errors.push(
            {
              name: `${this.translateService.trans(this.TOKEN_HEADER_CREATED_AT)}`,
              message: `${this.translateService.trans('modals.importer.date_incorrect_format')}`+': '+this.leadsCsvImported[i][this.COLUMN_CREATED_DATE],
              type: 'error',
              line: i + 2,
              leadN: i + 1
            });
        }
      }
      if (this.leadsCsvImported[i][this.COLUMN_CLOSE_DATE]) {
        if (moment(this.leadsCsvImported[i][this.COLUMN_CLOSE_DATE], 'DD/MM/YYYY', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_CLOSE_DATE], 'DD/M/YYYY', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_CLOSE_DATE], 'DD/MM/YYYY H:mm:ss', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_CLOSE_DATE], 'DD/M/YYYY H:mm:ss', true).isValid()) {
        } else {
          this.errors.push(
            {
              name: `${this.translateService.trans(this.TOKEN_HEADER_CLOSE_DATE)}`,
              message: `${this.translateService.trans('modals.importer.date_incorrect_format')}`+': '+this.leadsCsvImported[i][this.COLUMN_CLOSE_DATE],
              type: 'error',
              line: i + 2,
              leadN: i + 1
            });
        }
      }
      if (this.leadsCsvImported[i][this.COLUMN_ON_TRACK_DATE]) {
        if (moment(this.leadsCsvImported[i][this.COLUMN_ON_TRACK_DATE], 'DD/MM/YYYY', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_ON_TRACK_DATE], 'DD/M/YYYY', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_ON_TRACK_DATE], 'DD/MM/YYYY H:mm:ss', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_ON_TRACK_DATE], 'DD/M/YYYY H:mm:ss', true).isValid()) {
        } else {
          this.errors.push(
            {
              name: `${this.translateService.trans(this.TOKEN_HEADER_ON_TRACK_DATE)}`,
              message: `${this.translateService.trans('modals.importer.date_incorrect_format')}`+': '+this.leadsCsvImported[i][this.COLUMN_ON_TRACK_DATE],
              type: 'error',
              line: i + 2,
              leadN: i + 1
            });
        }
      }
      if (this.leadsCsvImported[i][this.COLUMN_ARCHIVED_DATE]) {
        if (moment(this.leadsCsvImported[i][this.COLUMN_ARCHIVED_DATE], 'DD/MM/YYYY', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_ARCHIVED_DATE], 'DD/M/YYYY', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_ARCHIVED_DATE], 'DD/MM/YYYY H:mm:ss', true).isValid()
          || moment(this.leadsCsvImported[i][this.COLUMN_ARCHIVED_DATE], 'DD/M/YYYY H:mm:ss', true).isValid()) {
        } else {
          this.errors.push(
            {
              name: `${this.translateService.trans(this.TOKEN_HEADER_ARCHIVED_DATE)}`,
              message: `${this.translateService.trans('modals.importer.date_incorrect_format')}`+': '+this.leadsCsvImported[i][this.COLUMN_ARCHIVED_DATE],
              type: 'error',
              line: i + 2,
              leadN: i + 1
            });
        }
      }
      this.progressStatus += progressPerItem;
    }
    this.processStatusDate = this.STATUS_COMPLETE;
  }

  checkChannels(channelsFind: any): void {
    this.processStatusChannel = this.STATUS_IN_PROGRESS;
    const progressPerItem = this.progresSteps / this.leadsCsvImported.length;
    for (let i = 0; i < this.leadsCsvImported.length; i++) {
      const channelName = this.leadsCsvImported[i][this.COLUMN_CHANNEL];
      if (channelName) {
        const isCorrect = channelsFind.find(x => x.name.toLowerCase() === channelName.toLowerCase());
        if (!isCorrect) {
          this.errors.push(
            {
              name: channelName,
              message: this.translateService.trans('modals.importer.channel_not_found'),
              type: 'warning',
              line: i + 2,
              leadN: i + 1
            });
          this.processStatusChannel = this.STATUS_ERROR;
          if (this.processStatusSaveLeads !== this.STATUS_ERROR) {
            this.processStatusSaveLeads = this.STATUS_WARNING;
          }
        }
      }
      this.progressStatus += progressPerItem;
    }
    if (this.processStatusChannel !== this.STATUS_ERROR) {
      this.processStatusChannel = this.STATUS_COMPLETE;
    }
  }

  checkBrands(brandsFind: any): void {

    this.processStatusBrands = this.STATUS_IN_PROGRESS;
    const progressPerItem = this.progresSteps / this.leadsCsvImported.length;
    for (let i = 0; i < this.leadsCsvImported.length; i++) {
      const brandName = this.leadsCsvImported[i][this.COLUMN_BRAND];
      if (brandName) {
        const isCorrect = brandsFind.find(x => x.name.toLowerCase() === brandName.toLowerCase());
        if (!isCorrect) {
          this.errors.push(
            {
              name: brandName,
              message: this.translateService.trans('modals.importer.brand_not_found'),
              type: 'warning',
              line: i + 2,
              leadN: i + 1
            });
          this.processStatusBrands = this.STATUS_ERROR;
          if (this.processStatusSaveLeads !== this.STATUS_ERROR) {
            this.processStatusSaveLeads = this.STATUS_WARNING;
          }
        }
      }
      this.progressStatus += progressPerItem;
    }
    if (this.processStatusBrands !== this.STATUS_ERROR) {
      this.processStatusBrands = this.STATUS_COMPLETE;
    }
  }

  checkDealers(dealersFind: any): void {
    this.processStatusDealers = this.STATUS_IN_PROGRESS;
    const progressPerItem = this.progresSteps / this.leadsCsvImported.length;
    for (let i = 0; i < this.leadsCsvImported.length; i++) {
      const dealerName = this.leadsCsvImported[i][this.COLUMN_DEALER];
      if (dealerName) {
        const isCorrect = dealersFind.find(x => x.name.toLowerCase() === dealerName.toLowerCase());
        if (!isCorrect) {
          this.errors.push(
            {
              name: dealerName,
              message: this.translateService.trans('modals.importer.dealer_not_found'),
              type: 'warning',
              line: i + 2,
              leadN: i + 1
            });
          this.processStatusDealers = this.STATUS_ERROR;
          if (this.processStatusSaveLeads !== this.STATUS_ERROR) {
            this.processStatusSaveLeads = this.STATUS_WARNING;
          }
        }
      }
      this.progressStatus += progressPerItem;
    }
    if (this.processStatusDealers !== this.STATUS_ERROR) {
      this.processStatusDealers = this.STATUS_COMPLETE;
    }
  }

  checkUsers(usersFind: any): void {
    this.processStatusUsers = this.STATUS_IN_PROGRESS;
    const progressPerItem = this.progresSteps / this.leadsCsvImported.length;
    for (let i = 0; i < this.leadsCsvImported.length; i++) {
      const userName = this.leadsCsvImported[i][this.COLUMN_USER];
      if (userName) {
        const isCorrect = usersFind.find(x => x.name.toLowerCase() === userName.toLowerCase());
        if (!isCorrect) {
          this.errors.push(
            {
              name: userName,
              message: this.translateService.trans('modals.importer.user_not_found'),
              type: 'error',
              line: i + 2,
              leadN: i + 1
            });
          this.processStatusUsers = this.STATUS_ERROR;
          this.processStatusSaveLeads = this.STATUS_ERROR;
        }
      }
      this.progressStatus += progressPerItem;
    }
    if (this.processStatusUsers !== this.STATUS_ERROR) {
      this.processStatusUsers = this.STATUS_COMPLETE;
    }
  }

  checkBulk(idFind: any): void {
    this.processStatusOfferId = this.STATUS_IN_PROGRESS;
    const progressPerItem = this.progresSteps / this.leadsCsvImported.length;
    for (let i = 0; i < this.leadsCsvImported.length; i++) {
      const id = this.leadsCsvImported[i][this.COLUMN_ID];
      if (id) {
        const isCorrect = idFind.find(x => x === id);
        if (isCorrect) {
          this.errors.push(
            {
              name: id,
              message: this.translateService.trans('modals.importer.id_duplicated'),
              type: 'error',
              line: i + 2,
              leadN: i + 1
            });
          this.processStatusOfferId = this.STATUS_ERROR;
          this.processStatusSaveLeads = this.STATUS_ERROR;
        }
      }
      this.progressStatus += progressPerItem;
    }
    if (this.processStatusOfferId !== this.STATUS_ERROR) {
      this.processStatusOfferId = this.STATUS_COMPLETE;
    }

  }

  mapType(types: any): void {
    this.processStatusType = this.STATUS_IN_PROGRESS;
    const typesMapped = types.map((type: any) => type.name);
    for (const lead of this.leadsCsvImported) {
      for (const token of typesMapped) {
        if (this.translateService.trans(`pages.leads.type.${token}`).toLowerCase() === lead[this.COLUMN_TYPE].toLowerCase()) {
          lead[this.COLUMN_TYPE] = token;
        }
      }
    }
    this.processStatusType = this.STATUS_COMPLETE;
  }

  dropped(event): void {
    this.files = event.files;
    for (const droppedFile of event) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          const reader = new FileReader();
          this.readerOnload(reader);
          reader.readAsText(file);
          this.dropHereFileName = file.name;

        });
      }
    }
  }

  getTypeTranslation(type: string): string {
    let translateType = this.translateService.trans(`pages.leads.type.${type}`);
    if (translateType.includes('pages.leads.type')) {
      translateType = this.translateService.trans('pages.leads.type.');
    }

    return translateType;
  }

  private readerOnload(reader: FileReader): void {
    reader.onload = () => {
      try {
        this.readFileCsv(reader);
      } catch (e) {
        // console.error(e);
      }
    };
  }
  private validateEmail(email) {
    /* tslint:disable */
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // tslint-disable-line no-use-before-define
    /* tslint:enable */
    return re.test(email);
  }
  private validatePhone(value) {
    if (!value) return null;
    const phoneService = new PhoneService();
    return phoneService.phoneIsValid(value);
  }

  private validateVat(value) {

    if (!value) return null;
    return SpanishIdisValid(value)

  }

}
